import { Activity } from '../../models/activity';
import { ApiResponse, httpService } from '../httpService';

export const ActivitiesApiURL = '/api/Activities';

export const getActivities = async (
  skip: number,
  take: number,
  filter?: string
): Promise<ApiResponse<Activity>> => {
  const response = await httpService.get<ApiResponse<Activity>>(
    ActivitiesApiURL,
    {
      params: {
        skip,
        take,
        filter,
      },
    }
  );

  return response.data;
};

export const addNewActivity = async (
  newActivity: Partial<Activity>
): Promise<void> => {
  await httpService.post(ActivitiesApiURL, newActivity);
};

export const getActivity = async (idActivity: string): Promise<Activity> => {
  const response = await httpService.get<Activity>(
    `${ActivitiesApiURL}/${idActivity}`
  );

  return response.data;
};

export const editActivity = async (
  idActivity: string,
  editActivityInfo: Partial<Activity>
): Promise<void> => {
  await httpService.put(`${ActivitiesApiURL}/${idActivity}`, editActivityInfo);
};

export const getLatestActivity = async (taskId: string, employeeId: string): Promise<{ comment: string; minutes: number; ticketIdentification: string | null } | null> => {
  try {
    const response = await httpService.get<{ comment: string; minutes: number; ticketIdentification: string | null }>(
      `${ActivitiesApiURL}/get-latest`,
      {
        params: {
          taskId,
          employeeId,
        },
      }
    );

    return response.data;
  } catch (error) {
    return null;
  }
};

export const deleteActivity = async (idActivity: string): Promise<void> => {
  await httpService.delete(`${ActivitiesApiURL}/${idActivity}`);
};
